import { authService } from './auth-service';
import Client from './jsonapi-client/Client';

let client = null;

export default function JSONApiClient() {

  const token = authService.getToken();
  if (!token) {
    client = null;
    // TODO should probably throw an error here.
    return;
  }

  client = new Client(process.env.REACT_APP_API_BASE_URL, {
    header: {
      Authorization: `Bearer ${authService.getToken()}`
    }
  });
  return client;
}

export function unauthorisedJSONApiClient() {
  return new Client(process.env.REACT_APP_API_BASE_URL, {});
}



/** WEBPACK FOOTER **
 ** ./src/utils/jsonapi-service.js
 **/